/*
 * @Description: 带logo和搜索框头部
 * @Author: ywj
 * @Date: 2025-02-08 09:33:25
 * @LastEditTime: 2025-04-18 11:46:28
 * @LastEditors: ywj@originqc.com
 */
import React, { useState, useRef, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import CustomSearch from '../custom-search';
import GoodsMenu from '../category-menu';
import logoIcon from './imgs/logo.svg';
import classIcon from './imgs/class.png'
import { getHomeGoods } from '@/api/home'
import useBackToTop from '@/hooks/useBackToTop';
import './index.scss';

interface IHeadProps {
  type: string,  //logo 首页，classify 列表、详情页
  setSecondId?: any
  setSearchName?: any
  searchName?: string
}
const CommonHead: React.FC<IHeadProps> = (props) => {
  const [showMenu, setShowMenu] = useState(false);
  const [category, setCategory] = useState();
  const { type, setSecondId, setSearchName, searchName } = props;
  const menuRef = useRef<HTMLDivElement | null>(null);
  const classifyRef = useRef<HTMLDivElement | null>(null);
  const { isVisible, scrollToTop } = useBackToTop(300); // 调用自定义 Hook
  const navigate = useNavigate();
  useEffect(() => {
    handleCategory()
  }, []);
  useEffect(() => { 
    if (!isVisible) { 
      setShowMenu(false);
    }
  },[isVisible])
  const handleMenu = () => { 
    setShowMenu(true);
  }


  const handleMenuLeave = () => {
    setShowMenu(false);
  }
  const handleHome = () => {
    navigate('/home')
  };


  // 全部分类
  const handleCategory = async () => {
    try {
      const res = await getHomeGoods();
      if (res.success) {

        setCategory(res.obj.node);
      }
    } catch {

    }
  }

  return (
    <div className="common-head-container">
      <div className='common-head-content' ref={menuRef}>
        <div className="home-box-top">
          <div className="home-box-top-left">
            {type === 'logo' ? <div className='classify-box'>
              <img src={logoIcon} alt="logo" className='logo' />
              {isVisible && <div className="classify"
                // onMouseEnter={handleMenu}
                onClick={handleMenu}
                ref={classifyRef}
              // onMouseLeave={() => setShowMenu(false)}
              >
                <img src={classIcon} alt='分类' className='class-icon'/>
                <span >全部分类</span>
              </div>}</div> :
              <div className='classify-box'>
                <div className="logo-text" onClick={handleHome}>
                  {/* <span className='logo-text-title'>本源量子商城</span>
                  <p className='logo-text-title-en'>ORIGIN QUANTUM MALL</p> */}
                  <img src={logoIcon} alt="logo" className='logo' />
                </div>
                <div className="classify"
                  // onMouseEnter={handleMenu}
                  onClick={handleMenu}
                  ref={classifyRef}
                // onMouseLeave={() => setShowMenu(false)}
                >
                  <img src={classIcon} alt='分类' />
                  <span >全部分类</span>
                </div>
              </div>

            }
          </div>
          <div className="home-box-top-right">
            <CustomSearch setSecondId={setSecondId} setSearchName={setSearchName} />
          </div>
        </div>
        {/* //首页的分类菜单，向上滚动到banner时，消失，列表和详情没此要求 */}
        {(type==='logo'?(isVisible&&showMenu):showMenu )&& <div
          className="goods-menu-wrapper"
          onMouseEnter={handleMenu}
          onMouseLeave={handleMenuLeave}
        >
          <GoodsMenu
            categoryData={category}
            setSearchName={setSearchName}
            searchName={searchName}
            handleMenuLeaveHead={handleMenuLeave}
            bgColor={'rgba(157, 160, 176, 1)'}
          />
        </div>}
      </div>
    </div>

  )
}

export default CommonHead;